<div class="row" *ngIf='readOnly'>
  <div class="col-md-12 col-sm-12 table-responsive no-border">
    <form [formGroup]="deviceForm" novalidate>
      <table class="table table-condensed">
        <tbody>
          <tr>
            <td class="col-sm-12 no-right-padding no-left-padding">
              <table class="table table-inner table-condensed ">
                <tbody>
                  <tr>
                    <th class="col-sm-4">Device Status</th>
                    <th class="col-sm-4">Commercial Distribution End Date</th>
                    <th class="col-sm-4">Reason for Device Discontinuation</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Device Status')">
                      <label controlName="deviceStatus"> </label> </td>
                    <td [ngClass]="isDefault('Commercial Distribution End Date')">
                      <label controlName="commercialDistributionEndDate"> </label> </td>
                    <td [ngClass]="isDefault('Reason for Device Discontinuation')">
                      <label controlName="reasonForDeviceDiscontinuation"> </label> </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="col-sm-12 no-right-padding no-left-padding">
              <table class="table-inner table-condensed  table-66">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Member State Where Device is Placed on the EU Market</th>
                    <th class="col-sm-6">New Device?</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Member State Where Device is Placed on the EU Market')">
                      <label controlName="memberStateForDevicePlacementInEu"></label>
                    </td>
                    <td [ngClass]="isDefault('New Device?')">
                      <label controlName="newDevice"></label>
                    </td>
                  </tr>
                </tbody>
              </table>

              <table formArrayName="membersAvailForm" class="table table-inner table-condensed ">
                <tbody>
                  <tr>
                    <th class="col-sm-4">Member State(s) Where Device is Made Available</th>
                    <th class="col-sm-4">Availability Start Date</th>
                    <th class="col-sm-4">Availability End Date</th>
                  </tr>
                  <ng-container *ngIf="membersAvailForm.controls.length; else emptyTemplate3fields">
                    <tr formGroupName="{{i}}" *ngFor="let item of membersAvailForm.controls; let i = index">
                      <td [ngClass]="isDefault('Member State(s) Where Device is Made Available')">
                        <label controlName="memberStateValue"></label> </td>
                      <td [ngClass]="isDefault('Member State(s) Where Device is Made Available')">
                        <label controlName="startDate"></label></td>
                      <td [ngClass]="isDefault('Member State(s) Where Device is Made Available')">
                        <label controlName="endDate"></label></td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="col-sm-12 no-right-padding no-left-padding">
              <table formArrayName="subStatusForm" class="table table-inner table-condensed ">
                <tbody>
                  <tr>
                    <th class="col-sm-4">Device SubStatus</th>
                    <th class="col-sm-4">SubStatus Start Date</th>
                    <th class="col-sm-4">SubStatus End Date</th>
                  </tr>
                  <ng-container *ngIf="subStatusForm.controls.length; else emptyTemplate3fields">
                    <tr formGroupName="{{i}}" *ngFor="let item of subStatusForm.controls; let i = index">
                      <td [ngClass]="isDefault('Device SubStatus')">
                        <label controlName="subStatusValue"></label> </td>
                      <td [ngClass]="isDefault('Device SubStatus')">
                        <label controlName="subStatusStartDate"></label> </td>
                      <td [ngClass]="isDefault('Device SubStatus')">
                        <label controlName="subStatusEndDate"></label> </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
              <table class="table-inner table-condensed  table-33">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Device Recall Scope</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Device Recall Scope')">
                      <label controlName="deviceRecallScope"></label> </td>
                  </tr>
                </tbody>
              </table>
              <table formArrayName="recallForm" class="table table-inner table-condensed  table-66">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Device Recall Precision</th>
                    <th class="col-sm-6">Language</th>
                  </tr>
                  <ng-container *ngIf="recallForm.controls.length; else emptyTemplate2fields">
                    <tr formGroupName="{{i}}" *ngFor="let item of recallForm.controls; let i = index">
                      <td [ngClass]="isDefault('Device Recall Precision')">
                        <label controlName="value"></label> </td>
                      <td [ngClass]="isDefault('Device Recall Precision')">
                        <label controlName="languageQualifier"></label></td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="no-right-padding no-left-padding">
              <table class="table table-inner table-condensed  table-66">
                <tbody>
                  <tr>
                    <th>Customer Service Center Name</th>
                    <th>Customer Service Center Phone Number</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Customer Service Center Name')">
                      <label controlName="customerServiceCenterName"> </label> </td>
                    <td [ngClass]="isDefault('Customer Service Center Phone Number')">
                      <label controlName="customerServiceCenterPhone"> </label> </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="no-left-padding">
              <table class="table-inner table-condensed  table-33">
                <tbody>
                  <tr>
                    <th>Medical Insurance Code(s)</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Medical Insurance Code(s)')">
                      <table formArrayName="medicalInsuranceCodesForm">
                        <tbody>
                          <ng-container *ngIf="medicalInsuranceCodesForm.controls.length; else emptyTemplate1field">
                            <tr formGroupName="{{i}}"
                                *ngFor="let code of medicalInsuranceCodesForm.controls; let i = index">
                              <td  [ngClass]="isDefault('Medical Insurance Code(s)')"><label controlName="medicalInsuranceCode"></label></td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td></td>
          </tr>
          <tr>
            <td class="col-sm-12 no-right-padding no-left-padding">
              <table class="table table-inner table-condensed ">
                <tbody>
                  <tr>
                    <th>Eligible for Health Care Benefit or Reimbursement?</th>
                    <th>Health Care Benefit Code(s)</th>
                    <th>Reason for Not Providing Health Care Benefit Code</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Eligible for Health Care Benefit or Reimbursement?')"><label
                        controlName="eligibleForHealthCareBenefitsOrReimbursement"></label></td>

                    <td [ngClass]="isDefault('Health Care Benefit Code(s)')">
                      <table formArrayName="healthBenefitCodesForm">
                        <tbody>
                          <ng-container *ngIf="healthBenefitCodesForm.controls.length; else emptyTemplate1field">
                            <tr formGroupName="{{i}}"
                                *ngFor="let code of healthBenefitCodesForm.controls; let i = index">
                              <td [ngClass]="isDefault('Health Care Benefit Code(s)')"><label
                                  controlName="value"></label>
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </td>

                    <td [ngClass]="isDefault('Reason for Not Providing Health Care Benefit Code')"><label
                        controlName="reasonForNotProvidingHealthCareBenefitCode"></label></td>
                  </tr>

                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="col-sm-12 no-right-padding no-left-padding">
              <table class="table table-inner table-condensed ">
                <tbody>
                  <tr>
                    <th class="col-sm-4">Device Exempt from FDA Premarket Submission?</th>
                    <th class="col-sm-4">Prescription Use (Rx)?</th>
                    <th class="col-sm-4">Over the Counter (OTC)?</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Device Exempt from FDA Premarket Submission?')">
                          <label controlName="premarketAuthorizationExempt"> </label> </td>
                    <td [ngClass]="isDefault('Prescription Use (Rx)?')">
                          <label controlName="prescriptionUseRx"> </label> </td>
                    <td [ngClass]="isDefault('Over the Counter (OTC)?')">
                          <label controlName="overTheCounterOtc"> </label> </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed ">
                <tbody>
                  <tr>
                    <th class="col-sm-4">FDA Premarket Submission Number(s)</th>
                    <th class="col-sm-4">FDA Supplement Number(s)</th>
                    <th class="col-sm-4">FDA Listing Number(s)</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('FDA Premarket Authorization')">
                      <table formArrayName="premarketAuthorizationForm">
                        <tbody>
                          <ng-container *ngIf="premarketAuthorizationForm.controls.length; else emptyTemplate2fields">
                            <tr formGroupName="{{i}}"
                                *ngFor="let code of premarketAuthorizationForm.controls; let i = index">
                              <td [ngClass]="isDefault('FDA Premarket Authorization')"><label controlName="authorizationNumber"></label></td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </td>
                    <td [ngClass]="isDefault('FDA Premarket Authorization')">
                      <table formArrayName="premarketAuthorizationForm">
                        <tbody>
                          <ng-container *ngIf="premarketAuthorizationForm.controls.length; else emptyTemplate2fields">
                            <tr formGroupName="{{i}}"
                                *ngFor="let code of premarketAuthorizationForm.controls; let i = index">
                              <td [ngClass]="isDefault('FDA Premarket Authorization')"><label controlName="supplementNumber"></label></td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </td>
                    <td [ngClass]="isDefault('FDA Listing Number(s)')" formArrayName="fdaListingNumbersForm">
                      <table>
                        <tbody>
                          <ng-container *ngIf="fdaListingNumbersForm.controls.length; else emptyTemplate1field">
                            <tr formGroupName="{{i}}"
                                *ngFor="let code of fdaListingNumbersForm.controls; let i = index">
                              <td [ngClass]="isDefault('FDA Listing Number(s)')"><label controlName="fdaListingNumber"></label></td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
  <td class="col-sm-12 no-right-padding no-left-padding"  [ngClass]="isDefault('Customer Contact')">
              <table formArrayName="customerContactForm" class="table table-inner table-condensed ">
                <tbody>
                  <tr>
                    <th class="col-sm-4">Customer Contact Email</th>
                    <th class="col-sm-3">Customer Contact Phone - Country Code</th>
                    <th class="col-sm-3">Customer Contact Phone - Area Code and Subscriber Number</th>
                    <th class="col-sm-2">Customer Contact Phone - Extension</th>
                  </tr>
                  <ng-container *ngIf="customerContactForm.controls.length; else emptyTemplate4fields">
                    <tr formGroupName="{{i}}" *ngFor="let contact of customerContactForm.controls; let i = index">
            <td [ngClass]="isDefault('Customer Contact')"><label controlName="email"></label>
                      </td>
            <td [ngClass]="isDefault('Customer Contact')"><label controlName="telCountryCode"></label>
                      </td>
            <td [ngClass]="isDefault('Customer Contact')"><label controlName="telNumber"></label>
                      </td>
            <td [ngClass]="isDefault('Customer Contact')"><label controlName="extension"></label>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="col-sm-12 no-right-padding no-left-padding">
              <div class="artg-section">
                <table formArrayName="artgForm" class="table table-inner table-condensed artg-table">
                  <tbody>
                    <tr>
                      <th class="col-sm-2">ARTG ID</th>
                      <th class="col-sm-3">Supporting Document URL</th>
                      <th class="col-sm-2">Supporting Document Type</th>
                      <th class="col-sm-3">Supporting Document Effective Date</th>
                      <th class="col-sm-2">Supporting Document End Date</th>
                    </tr>
                    <ng-container *ngIf="artgForm.controls.length; else emptyTemplate5fields">
                      <tr formGroupName="{{i}}" *ngFor="let item of artgForm.controls; let i = index">
                        <td [ngClass]="isDefault('ARTG ID')">
                          <label controlName="artgId"> </label>
                        </td>
                        <td [ngClass]="isDefault('Supporting Document URL')">
                          <label controlName="supportingDocumentUrl"> </label>
                        </td>
                        <td [ngClass]="isDefault('Supporting Document Type')">
                          <label controlName="supportingDocumentType"> </label>
                        </td>
                        <td [ngClass]="isDefault('Supporting Document Effective Date')">
                          <label controlName="supportingDocumentEffectiveDate"> </label>
                        </td>
                        <td [ngClass]="isDefault('Supporting Document End Date')">
                          <label controlName="supportingDocumentEndDate"> </label>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>
<ng-template #emptyTemplate1field>
  <tr>
    <td><label></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate2fields>
  <tr>
    <td><label></label></td>
    <td><label></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate3fields>
  <tr>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate4fields>
  <tr>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate5fields>
  <tr>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
  </tr>
</ng-template>
